'use strict';

var getComponentName = require('../../../../_virtual/getComponentName.js_commonjs-exports.js');
var index = require('../../node_modules/function.prototype.name/index.js');
require('../../node_modules/react-is/index.js');
var index$1 = require('../../../../_virtual/index.js_commonjs-module10.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getComponentName;

var _functionPrototype = _interopRequireDefault(index);

var _reactIs = index$1.reactIs.exports;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getComponentName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return Component.displayName || (0, _functionPrototype["default"])(Component);
  }

  if ((0, _reactIs.isForwardRef)({
    type: Component,
    $$typeof: _reactIs.Element
  })) {
    return Component.displayName;
  }

  if ((0, _reactIs.isMemo)(Component)) {
    return getComponentName(Component.type);
  }

  return null;
}

}(getComponentName.__exports));
